import React from 'react'
import './Uifooter.css'
const Uifooter = () => {
  return (
    <div id='uifooter'>
      <div className="section">
        <div className="container">
          <h1 className="heading">
           Design That Drives Results – Let’s Start
          </h1>
          <h3 className="subHeading">
            Get in touch today and bring your ideas to life with impactful design.
          </h3>
        </div>
      </div>
    </div>
  )
}

export default Uifooter